<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.payslip') }} > {{ $t('sidebar.create') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <PayrollPaySlipForm
        :prlCode="paySlipLatestCode.next"
        :groups="groups"
        :conditions="conditions"
        :employees="employees"
        :isSubmitted="isSubmitted"
        :disabled="disabled"
        :form.sync="form"
        :showActionButtons="hasRoleEdit"
        @onSubmit="handleSubmit"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { toISODateString } from '@/helpers'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      form: null,
    }
  },

  computed: {
    ...mapState('payroll', {
      paySlipLatestCode: 'paySlipLatestCode',
      groups: 'employeeGroupList',
      conditions: 'conditionList',
    }),
    ...mapState('hrm', {
      employees: 'employeeList',
    }),
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.payroll.title'),
      current: {
        app_name: 'payroll',
        app_id: 14,
        module_id: 1,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 0,
      submenuAtIdx: 1,
    })
  },

  created () {
    this.fetchData()
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('payroll', {
      getPaySlipLatestCode: 'getPaySlipLatestCode',
      getEmployeeGroupList: 'getEmployeeGroupList',
      getConditionList: 'getConditionList',
      createPaySlip: 'createPaySlip',
    }),
    ...mapActions('hrm', {
      getEmployeeList: 'getEmployeeList',
    }),
    async fetchData () {
      this.loading = true
      const params = { page: 1, limit: 100000 }
      await Promise.all([
        this.getPaySlipLatestCode(),
        this.getEmployeeGroupList(params),
        this.getConditionList(params),
        this.getEmployeeList(params),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    getData (form = {}) {
      const employees = form.employees.map((emp) => {
        return {
          'emp_id': emp.empId,
          'emp_name': emp.name,
          'wage_amount': emp.wageAmount,
          'net': emp.net,
          'conditions': emp.conditions.map((cond) => {
            return {
              'condition_id': cond.conditionId,
              'name': cond.name,
              'amount': cond.amount,
              'is_increment': cond.isIncrement,
              'is_editable': cond.isEditable,
            }
          }),
        }
      })
      const net = employees.reduce((total, cur) => total + cur.net, 0)
      return {
        'date_start': toISODateString(form.dateStart),
        'date_end': toISODateString(form.dateEnd),
        'note': form.note,
        'net': net,
        'employees': employees,
      }
    },
    async handleSubmit (form = {}) {
      const data = this.getData(form)
      const response = await this.createPaySlip(data)
      if (response.success) {
        this.disabled = false
        this.isSubmitted = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: this.paySlipLatestCode.next }),
          color: 'success',
          icon: 'cloud',
        })
        this.$router.push({
          name: 'PaySlipEdit',
          query: {
            id: response.data._id,
            code: response.data.prl_code,
            ignoreDiscardAlert: true,
          },
        })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/payroll/payslip/Create.vue